export const SET_TOKEN = 'SET_TOKEN'

export const LOGOUT = 'LOGOUT'

export const SET_USER_INFO = 'SET_USER_INFO'